export default __webpack_public_path__ + "static/top-b396a6a50b5902377c7a657780ce9070.png";